export default __webpack_public_path__ + "static/media/OPEND FAN COVER ACCIDENT SIMULATOR.174108d7.jpg";